var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon / keyboard_arrow_down"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_987_2905",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 24 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_987_2905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "keyboard_arrow_down",
    d: "M12 8.6L18 14.6L16.6 16L12 11.4L7.4 16L6 14.6L12 8.6Z",
    fill: "#49247D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/keyboard_arrow_up.f16a4cadd970064c004312790933b2ac.svg";
export { ForwardRef as ReactComponent };